import { FormControl, Autocomplete, Grid, TextField } from "@mui/material";

export function BusinessUnitSelect({ handleSelect, buNumbers, errors }) {
  return (
    <FormControl required fullWidth>
      <Autocomplete
        id="grouped-business-unit-select-sample-request-details-autocomplete"
        onChange={(e, newValue) =>
          handleSelect(
            "businessUnitSelect",
            `${newValue.number} - ${newValue.name}`
          )
        }
        loading={true}
        options={buNumbers}
        groupBy={(option) => option.department}
        getOptionLabel={(option) => `${option.number} - ${option.name}`}
        fullWidth
        renderOption={(props, option) => (
          <Grid {...props} container ml={3} mb={2}>
            <Grid item xs={12}>
              {option.number}
            </Grid>
            <Grid item xs={12}>
              <small>{option.name}</small>
            </Grid>
          </Grid>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            required
            label="Business Unit number"
            error={errors && errors.businessUnit && true}
            helperText={
              errors && errors.businessUnit !== "" ? errors.businessUnit : ""
            }
          />
        )}
      />
    </FormControl>
  );
}
